import { Typography } from "@material-ui/core";
import React from "react";

import { DIAGNOSIS_QUESTION_TEXT, LOCATION_YIELD } from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleScaleSelector } from "../DiagnosisInvestmentStyleScaleSelector";

import { useStepStyles } from "./stepStyles";

type LocationYieldStepProps = {
  locationYieldPreference: number | null;
  onLocationYieldPreferenceChange: (value: number) => void;
};

const LocationYieldStep: React.FC<LocationYieldStepProps> = ({
  locationYieldPreference,
  onLocationYieldPreferenceChange,
}) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>安全性と収益</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[8]}</Typography>
      <DiagnosisInvestmentStyleScaleSelector
        min={LOCATION_YIELD.min}
        max={LOCATION_YIELD.max}
        leftLabel={LOCATION_YIELD.leftLabel}
        rightLabel={LOCATION_YIELD.rightLabel}
        notes={LOCATION_YIELD.notes}
        footnote={LOCATION_YIELD.footnote}
        value={locationYieldPreference}
        onChange={onLocationYieldPreferenceChange}
      />
    </>
  );
};

export default LocationYieldStep;
